module.exports = __webpack_public_path__ + "static/media/EN.15e737a0.svg";